import { useCallback, useEffect, useState } from 'react'

const useBannerOffset = () => {
  const [bannerHeight, setBannerHeight] = useState(0)

  const handleBannerHeightChange = useCallback((height) => {
    setBannerHeight(typeof height === 'number' ? height : 0)
  }, [])

  useEffect(() => {
    if (typeof document === 'undefined') return

    const root = document.documentElement
    root.style.setProperty('--dpoday-banner-height', `${bannerHeight}px`)
    return () => {
      root.style.removeProperty('--dpoday-banner-height')
    }
  }, [bannerHeight])

  return { bannerHeight, handleBannerHeightChange }
}

export default useBannerOffset
